import { createAction } from 'Lib/reduxUtils';

import {
  FACEBOOK_SDK_BLOCKED,
  FACEBOOK_SDK_INITIALIZED,
  RESET_FACEBOOK_TOKEN_STATE,
  VALIDATE_FACEBOOK_TOKEN_ERROR,
  VALIDATE_FACEBOOK_TOKEN_SUCCESS,
} from './constants';

export const facebookInitialized = createAction(FACEBOOK_SDK_INITIALIZED);
export const facebookSdkBlocked = createAction(FACEBOOK_SDK_BLOCKED);

export const validateFacebookTokenSuccess = createAction(VALIDATE_FACEBOOK_TOKEN_SUCCESS);
export const validateFacebookTokenError = createAction(VALIDATE_FACEBOOK_TOKEN_ERROR);
export const resetFacebookTokenState = createAction(RESET_FACEBOOK_TOKEN_STATE);
